// Objet qui contient les propriétés pour chaque police
export const typesPolices = {
	Arial: {
		facteur_taille_police: 0.6,
		epaisseur_police: "normal",
		coef_marge: 0.28,
		coef_marge_windows: 0.28,
		coef_marge_double: -0.226190476,
		coef_marge_double_windows: -0.226190476,
		distance_soulignage: 0.4,
		distance_barre: "45%",
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	Marelle: {
		facteur_taille_police: 0.52,
		epaisseur_police: "normal",
		coef_marge: 0.24,
		coef_marge_windows: 0.24,
		coef_marge_double: -0.24,
		coef_marge_double_windows: -0.24,
		distance_soulignage: 0.4,
		distance_barre: "60%",
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	"Marelle Bâton": {
		facteur_taille_police: 0.52,
		epaisseur_police: "normal",
		coef_marge: 0.24,
		coef_marge_windows: 0.24,
		coef_marge_double: -0.24,
		coef_marge_double_windows: -0.24,
		distance_soulignage: 0.3,
		distance_barre: "60%",
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	"AA Cursive": {
		facteur_taille_police: 0.75,
		epaisseur_police: "normal",
		coef_marge: 0.35,
		coef_marge_windows: 0.3125,
		coef_marge_double: -0.260416667,
		coef_marge_double_windows: -0.260416667,
		distance_soulignage: 0.3,
		distance_barre: "45%",
		ligatures: [0, 1],
		bouton_ligatures_display: null,
	},
	"Open Dyslexic": {
		facteur_taille_police: 0.45,
		epaisseur_police: "normal",
		coef_marge: 0.35,
		coef_marge_windows: 0.35,
		coef_marge_double: -0.260416667,
		coef_marge_double_windows: -0.260416667,
		distance_soulignage: 0.5,
		distance_barre: "50%",
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	Acceseditionscursive: {
		facteur_taille_police: 0.674,
		epaisseur_police: "normal",
		coef_marge: 0.272,
		coef_marge_windows: 0.242857143,
		distance_soulignage: 0.379,
		distance_barre: "45%",
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	Luciole: {
		facteur_taille_police: 0.65,
		epaisseur_police: "normal",
		coef_marge: 0.29,
		coef_marge_windows: 0.29,
		coef_marge_double: -0.23015873,
		coef_marge_double_windows: -0.23015873,
		distance_soulignage: 0.379,
		distance_barre: "50%",
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
	Romain: {
		facteur_taille_police: 0.8,
		epaisseur_police: "bold",
		coef_marge: 0.3,
		coef_marge_windows: 0.334821429,
		distance_soulignage: 0.38,
		distance_barre: "60%",
		ligatures: [1, 0],
		bouton_ligatures_display: "none",
	},
};
